module.exports = __webpack_public_path__ + "static/media/spritesheet.ba16cc81.png";